import React, { useEffect, useRef, useState } from "react";
import { Button, Card, FullCard, Select, Spinner } from "../components/CommonComponents";
import {
    // tutorGrade,
    readingCompGrade,
    tutorRoles,
    tutorSubject,
    tutorTopic,
    tutorTeacherMethods,
    tutorBoard,
    translationLanguages,
    imgThemes
} from "../components/Mapping";
import Modal from 'react-modal';
import questionIcon from "../assets/questionIcon.svg";
import cloud from "../assets/cloud.svg";
import ansIcon from "../assets/ansIcon.svg";
import DOMPurify from 'dompurify'
import { nanoid } from "nanoid";
import { pairwise } from "../utils/hacks";
import ImageSpinner from "../components/spinner";
import SimpleDropdown from "../components/SimpleDropdown";
import {
    generateImgURL,
    languageTranslationURL,
    readingCompInfoURL,
    pronounceTaraURL,
    likeReadingCompURL,
    dislikeReadingCompURL,
    chatHistoryReadingCompURL,
    downloadPDFTaraURL,
    askQuestionTaraURL,
    generateStoryTaraURL
} from "../api/serverAPI";
import { ImageUpload } from "../components/Fileupload";
import { select } from "react-cookies";
import Draggable from "react-draggable";
import axios from "axios";
import jsPDF from 'jspdf';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { MathKeyboard } from "../components/mathKeyboard";
import {
    BadgeHelp,
    ThumbsDown,
    ThumbsUp,
    Copy,
    MessageSquarePlus,
    Download,
} from 'lucide-react';

// console.log("ngoninittttttttttttt");
// window.speechSynthesis.cancel();
/**
 * BAse-64 encoding with a URL-safe charset
 * @param {string} s the string to encode
 * @returns {string} the encoded string
 */
function b64_urlsafe(s) {
    return btoa(s).replace(/\+/g, '-').replace(/\//g, '_').replace('=', '')
}

/**
 * A random string of n **bytes**.
 *
 * ..note::
 *    not all characters are a single byte. intermediate steps may contain fewer characters
 *    if String.fromCharCode returns a multi-byte sequence. This is normalized by base64.
 * @param n The number of bytes, defaults to 16
 * @returns {string} The randomly generated string.
 */
function randomString(n = 16) {
    return b64_urlsafe(String.fromCharCode(...crypto.getRandomValues(new Uint8Array(n))))
}
// Function to format timestamp
const formatDate = (timestamp) => {
    const date = new Date(timestamp);
    return date.toLocaleString(); // This formats the date and time in a readable format
};

// eslint-disable-next-line no-control-regex
const pattern = new RegExp('data:image/[^/]+;base64,[^\0]+\0\0');
let sender = randomString();

const ReadingComprehension = () => {
    const [selectedRole, setSelectedRole] = useState('student');
    const [selectedBoard, setSelectedBoard] = useState('CBSE');
    const [endpoint, setEndpoint] = useState('qa');
    const [selectedGrade, setSelectedGrade] = useState('4');
    const [selectedSubject, setSelectedSubject] = useState('English');
    const [selectedTopic, setSelectedTopic] = useState('Run');
    const [selectedTeacherMethod, setSelectedTeacherMethod] = useState('qa');
    const [messages, setMessages] = useState([]);
    const [selectedQuestionId, setSelectedQuestionId] = useState(null);
    const [loading, setLoading] = useState(false);
    const [currentQuestion, setCurrentQuestion] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [displayQuestionInput, setDisplayQuestionInput] = useState(true);
    const [voiceInput, setVoiceInput] = useState(false);

    const latestAnswerRef = useRef(null);
    const [disableTextArea, setDisableTextArea] = useState(true);
    const [imageFlag, setImageFlag] = useState(null);
    const [translationLanguage, setTranslationLanguage] = useState('hi')
    const [translatedText, setTranslatedText] = useState(null);
    const [currentAnswer, setCurrentAnswer] = useState(null);
    const [englishAnswer, setEnglishAnswer] = useState(null);
    const [translate, setTranslate] = useState(false);
    const [selectedFiles, setSelectedFiles] = useState(null);
    const [base64Data, setBase64Data] = useState(null);
    const [stream, setStream] = useState(true);
    const [autoScroll, setAutoScroll] = useState(true);
    const [textareaContent, setTextareaContent] = useState("");
    const [currentContext, setCurrentContext] = useState("");
    const [showPopup, setShowPopup] = useState(false);
    const [pronounceOutput, setPronounceOutput] = useState("");
    const [info, setInfo] = useState();
    const latestTranscriptRef = useRef('');
    const [showKeyboard, setShowKeyboard] = useState(false);
    const [showChatHistoryPopup, setShowChatHistoryPopup] = useState(false);
    const [chatHistory, setChatHistory] = useState([]);
    const [selectedSession, setSelectedSession] = useState(null);
    const [selectedSessionIndex, setSelectedSessionIndex] = useState(0);
    const [showDownload, setShowDownload] = useState(false);
    let bIndex = 0;
    // Dummy state to force re-render when updating the global sender variable
    const [, setDummy] = useState(0);

    // Function to refresh sender value
    const refreshSender = () => {
        clearAllVariables();
        sender = randomString(); // Update the global sender variable
        setDummy(prev => prev + 1); // Force re-render by updating a dummy state
        // Trigger a toast notification
        toast.info(`Session Refreshed: ${sender}`, {
            position: "bottom-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            theme: "light",
            progress: undefined,
        });
    };

    const clearAllVariables = () => {
        setSelectedRole('student');
        setSelectedBoard('CBSE');
        setEndpoint('qa');
        setSelectedGrade('4');
        setSelectedSubject('English');
        setSelectedTopic('Run');
        setSelectedTeacherMethod('qa');
        setMessages([]);
        setSelectedQuestionId(null);
        setLoading(false);
        setCurrentQuestion("");
        setErrorMessage("");
        setDisplayQuestionInput(true);
        setVoiceInput(false);

        latestAnswerRef.current = null;
        setDisableTextArea(true);
        setImageFlag(null);
        setTranslationLanguage('hi');
        setTranslatedText(null);
        setCurrentAnswer(null);
        setEnglishAnswer(null);
        setTranslate(false);
        setSelectedFiles(null);
        setBase64Data(null);
        setStream(true);
        setAutoScroll(true);
        setTextareaContent("");
        setCurrentContext("");
        setShowPopup(false);
        setShowChatHistoryPopup(false);
        setChatHistory([]);
        setSelectedSession(null);
        setSelectedSessionIndex(0);
        setPronounceOutput("");
        setInfo(undefined);
        latestTranscriptRef.current = '';
        setShowKeyboard(false);
        setShowDownload(false);
    };

    useEffect(() => {
        window?.speechSynthesis?.cancel();
    }, [])

    const handleInfo = async () => {
        setLoading(true);
        try {
            const url = readingCompInfoURL();
            const response = await axios.get(url);
            setLoading(false);
            if (response.status === 200) {
                setInfo(response.data.output);
            } else {
                console.error('Failed to generate info', response.data.output);
            }
        } catch (error) {
            setLoading(false);
            console.error('An error occurred while generating info', error);
        }
    };

    const handleLike = (id) => (event) => {
        const likeButton = event.currentTarget.firstChild;
        const dislikeButton = document.getElementById(`dislike-bot-response-${id}`).firstChild;
        const isLikeClicked = likeButton.style.color === 'blue';
        const isDislikeClicked = dislikeButton.style.color === 'red';

        // Toggle like button color
        if (isLikeClicked) {
            likeButton.style.color = 'black'; // Unclick like
        } else {
            likeButton.style.color = 'blue';  // Click like

            // If dislike is clicked, unclick it and toggle dislike in the backend
            if (isDislikeClicked) {
                dislikeButton.style.color = 'black'; // Unclick dislike
                toggleDislike(id, isDislikeClicked);  // Call function to hit API to remove dislike
            }
        }

        // Call function to toggle like in the backend
        toggleLike(id, isLikeClicked);
    };

    const handleDislike = (id) => (event) => {
        const dislikeButton = event.currentTarget.firstChild;
        const likeButton = document.getElementById(`like-bot-response-${id}`).firstChild;
        const isDislikeClicked = dislikeButton.style.color === 'red';
        const isLikeClicked = likeButton.style.color === 'blue';

        // Toggle dislike button color
        if (isDislikeClicked) {
            dislikeButton.style.color = 'black'; // Unclick dislike
        } else {
            dislikeButton.style.color = 'red';  // Click dislike

            // If like is clicked, unclick it and toggle like in the backend
            if (isLikeClicked) {
                likeButton.style.color = 'black'; // Unclick like
                toggleLike(id, isLikeClicked);  // Call function to hit API to remove like
            }
        }

        // Call function to toggle dislike in the backend
        toggleDislike(id, isDislikeClicked);
    };

    // Function to toggle like in the backend based on the current state
    const toggleLike = (id, isLikeClicked) => {
        const url = likeReadingCompURL();
        const payload = {
            email: JSON.parse(sessionStorage.getItem("userDetails"))['user_email'],
            session_id: sender,
            index: id
        };

        fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
        })
            .then(response => response.json())
            .then(data => {
                if (!isLikeClicked) {
                    toast.info("We're happy you found this helpful!", {
                        position: "bottom-right",
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        theme: "colored",
                    });
                }
            })
            .catch(error => {
                console.error('Error in API request:', error);
            });
    };

    // Function to toggle dislike in the backend based on the current state
    const toggleDislike = (id, isDislikeClicked) => {
        const url = dislikeReadingCompURL();
        const payload = {
            email: JSON.parse(sessionStorage.getItem("userDetails"))['user_email'],
            session_id: sender,
            index: id
        };

        fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
        })
            .then(response => response.json())
            .then(data => {
                if (!isDislikeClicked) {
                    toast.info("Noted! We're always learning from your feedback", {
                        position: "bottom-right",
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        theme: "colored",
                    });
                }
            })
            .catch(error => {
                console.error('Error in API request:', error);
            });
    };

    const handleCopyText = (elementId) => {
        const textToCopy = document.getElementById(elementId).innerText;

        navigator.clipboard.writeText(textToCopy)
            .then(() => {
                toast.success(`Response Copied to Clipboard`, {
                    position: "bottom-right",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    theme: "colored",
                    progress: undefined,
                });
            })
            .catch(err => {
                console.error('Failed to copy text: ', err);
            });
    };
    //Generate LLM summary pdf for entire chat
    const generatePDFForEntireChat = async () => {
        setLoading(true);
        const apiURL = downloadPDFTaraURL();
        // Determine session_id based on selectedSession
        const downloadSessionId = selectedSession ? selectedSession.session_id : sender;
        const payload = {
            email: JSON.parse(sessionStorage.getItem("userDetails"))['user_email'],
            session_id: downloadSessionId
        };

        try {
            const response = await axios.post(apiURL, payload, {
                headers: {
                    'Content-Type': 'application/json'
                },
                responseType: 'blob' // This handles the binary data response (PDF in this case)
            });

            // Create a download link and trigger it to download the file
            const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'summary.pdf'); // Set the file name
            document.body.appendChild(link);
            link.click();

            // Clean up
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url); // Free up the memory used by the blob URL

            console.log("PDF download triggered successfully!");
            setLoading(false);
        } catch (error) {
            console.error("Error downloading PDF: ", error);
            setLoading(false);
        }
    };
    //Generate simple pdf for one response
    const generatePDF = (question, answer) => {
        const doc = new jsPDF();

        // Add question to the PDF
        doc.setFontSize(16);
        doc.text('You:', 10, 10);
        doc.setFontSize(12);
        const wrappedQuestion = doc.splitTextToSize(question, 180); // Wrap text to fit within 180 units
        doc.text(wrappedQuestion, 10, 20);

        // Clean the HTML from the answer
        const cleanedAnswer = stripHTML(answer);

        // Add answer to the PDF
        doc.setFontSize(16);
        doc.text('Bot:', 10, 40);
        doc.setFontSize(12);
        const wrappedAnswer = doc.splitTextToSize(cleanedAnswer, 180); // Wrap text to fit within 180 units
        doc.text(wrappedAnswer, 10, 50);

        // Save the PDF
        doc.save('Chat.pdf');
    };

    const stripHTML = (html) => {
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = html;
        return tempDiv.textContent || tempDiv.innerText || '';
    };

    const handleTopicChange = (topic) => {
        setMessages([]);
        if (!disableTextArea) {
            setStream(false);
        }
        setSelectedTopic(topic);
        setTranslationLanguage('hi');
        setTranslatedText(null);
        setSelectedFiles(null);
    }

    useEffect(() => {
        const classname = document.getElementsByClassName('bot-response')
        if (classname[classname.length - 1] !== undefined) {
            //  console.log("--- ", classname[classname.length-1].id);
            const id = parseInt(classname[classname.length - 1].id.replace("bot-response", ''));
            // console.log(id);
            setTimeout(() => {
                if (voiceInput == true) {
                    // readAloud(id + 1, null);

                }
            }, 2000);

        }


    }, [document.getElementsByClassName('bot-response').length])

    const handleSubjectChange = (subject) => {
        setMessages([]);
        setSelectedSubject(subject);
        setSelectedTopic(tutorTopic[selectedGrade][subject][0].text);
        setTranslationLanguage('hi');
        setTranslatedText(null);
        setSelectedFiles(null);
    };

    const handleBoard = (option) => {
        setSelectedBoard(option);
    }

    const handleTranslationLanguageSelect = (option) => {
        setTranslationLanguage(option.value);
    };

    const handleSymbolClick = (symbol) => {
        // Append the clicked symbol to the current textarea value
        setCurrentQuestion((prevQuestion) => prevQuestion + symbol);
    };

    const handleLanguageTranslation = (id, msg) => {


        // Replace <img> tags with empty <div> tags and store the <img> tags
        const { modifiedHTML, imgTags } = replaceImagesWithDivsAndStore(msg);

        languageTranslationURL({
            text: modifiedHTML,
            target_lang: translationLanguage,
        }).then((response) => {
            // Restore <img> tags back to their original positions
            const restoredHTML = restoreImages(response.data['translated_text'], imgTags);
            setTranslatedText(restoredHTML);
            setMessages((m) => {
                if (m[id].fromUser) {
                    return m;
                }
                m[id].text = restoredHTML;
                return m;
            });
        }).catch(error => {
            alert("Can you please try again in sometime");
        });
    }

    const stopReadAloud = () => {


        window.speechSynthesis.cancel();

    };
    const readAloud = (id, msg) => {
        var idtsr = (parseInt(id) - 1).toString();
        var elem = document.getElementById('bot-response' + idtsr);

        window.speechSynthesis.cancel();
        if (!window.speechSynthesis) {
            console.error("Speech synthesis not supported.");
            return;
        }


        const textElement = elem.innerText.trim(); // Get the trimmed inner text
        // console.log(textElement);

        if (textElement) {
            const words = textElement.split(/\s+/);


            let currentIndex = -1;
            // let currentWordIndex = -1;

            const utterance = new SpeechSynthesisUtterance(textElement);
            const isHindi = /[\u0900-\u097F]/.test(textElement); // Check for Hindi characters


            const voices = window.speechSynthesis.getVoices();
            const hindiVoices = voices.filter(voice => voice.lang === "hi-IN");
            let selectedVoice;

            if (isHindi) {
                utterance.lang = "hi-IN";
                const hindiVoices = voices.filter(voice => voice.lang === "hi-IN");
                selectedVoice = hindiVoices.find(voice => voice.name.includes("Microsoft Swara Online (Natural) - Hindi (India)")) || hindiVoices[0];
            } else {

                utterance.lang = "en-US";
                const englishVoices = voices.filter(voice => voice.lang === "en-US" && voice.gender === "male");
                selectedVoice = englishVoices.find(voice => voice.name.includes("Microsoft David Desktop - English (United States)")) || englishVoices[0];
            }

            if (selectedVoice) {
                utterance.voice = selectedVoice;
            } else {
                console.warn("No appropriate voice found, using default voice.");
            }

            utterance.addEventListener("boundary", (event) => {
                const { charIndex } = event;

                // console.log(words[currentIndex])

                // highlightTheWord('bot-response' + idtsr, currentIndex);
                currentIndex++;


            });

            utterance.addEventListener("end", () => {

                console.log("Reading is completed");
            });

            window.speechSynthesis.speak(utterance);
        }
    };
    const readAloudpopup = (textElement) => {


        window.speechSynthesis.cancel();
        if (!window.speechSynthesis) {
            console.error("Speech synthesis not supported.");
            return;
        }


        // console.log(textElement);

        if (textElement) {
            const words = textElement.split(/\s+/);


            let currentIndex = -1;
            // let currentWordIndex = -1;

            const utterance = new SpeechSynthesisUtterance(textElement);
            const isHindi = /[\u0900-\u097F]/.test(textElement); // Check for Hindi characters


            const voices = window.speechSynthesis.getVoices();
            const hindiVoices = voices.filter(voice => voice.lang === "hi-IN");
            let selectedVoice;

            if (isHindi) {
                utterance.lang = "hi-IN";
                const hindiVoices = voices.filter(voice => voice.lang === "hi-IN");
                selectedVoice = hindiVoices.find(voice => voice.name.includes("Microsoft Swara Online (Natural) - Hindi (India)")) || hindiVoices[0];
            } else {

                utterance.lang = "en-US";
                const englishVoices = voices.filter(voice => voice.lang === "en-US" && voice.gender === "male");
                selectedVoice = englishVoices.find(voice => voice.name.includes("Microsoft David Desktop - English (United States)")) || englishVoices[0];
            }

            if (selectedVoice) {
                utterance.voice = selectedVoice;
            } else {
                console.warn("No appropriate voice found, using default voice.");
            }

            utterance.addEventListener("boundary", (event) => {
                const { charIndex } = event;

                // console.log(words[currentIndex])

                // highlightTheWord('bot-response' + idtsr, currentIndex);
                currentIndex++;


            });

            utterance.addEventListener("end", () => {

                console.log("Reading is completed");
            });

            window.speechSynthesis.speak(utterance);
        }
    };


    function highlightTheWord(id, wordIndex) {
        const element = document.getElementById(id);
        const words = element.innerText.split(/\s+/);
        const wordToHighlight = words[wordIndex];

        // Replace the word with itself wrapped in a span with inline styles
        const highlightedText = words.map((word, index) => {
            if (index === wordIndex) {
                // console.log(word);
                return `<span style="background-color: yellow; font-weight: bold;">${word}</span>`;
            } else {
                return word;
            }
        }).join(' ');

        // Update the inner HTML of the element with the highlighted text
        element.innerHTML = highlightedText;

    }

    // function removeHighlight(element) {
    //     element.innerHTML = element.innerText; // Reset innerHTML to remove highlighting
    // }


    const handleClassChange = (classItem) => {
        setMessages([]);
        // XXX: find somethig better. i`m too tired.
        if (classItem.toLowerCase().startsWith(`btech`)) classItem = `13`;
        setSelectedGrade(classItem);
        const subject = getSubjectOptions(classItem)[0].text;
        setSelectedSubject(subject);
        setSelectedTopic(tutorTopic[classItem][subject][0].text);
        setTranslationLanguage('hi');
        setTranslatedText(null);
        setSelectedFiles(null);
    };

    /**
     *
     * @param {InputEvent} e
     */
    const handleRoleChange = (e) => {
        setMessages([]);
        setSelectedFiles(null);
        const role = e.target.value.toLowerCase();
        setSelectedRole(() => role);
        setTranslationLanguage('hi');
        setTranslatedText(null);
    }

    /**
     *
     * @param {InputEvent} e
     */
    const handleTeacherMethod = (e) => {
        setMessages([]);
        setSelectedFiles(null);
        setSelectedTeacherMethod(() => e.target.value);
        setEndpoint(() => e.target.value);
        setTranslationLanguage('hi');
        setTranslatedText(null);
    }

    // Scroll to the latest answer
    useEffect(() => {
        const container = document.getElementById("chat-box")
        if (autoScroll || loading) {
            container.scrollTo({
                behavior: "smooth",
                top: container.scrollHeight,
            });
        }
    },
        [messages, autoScroll, loading]
    )

    const handleScroll = () => {
        const container = document.getElementById("chat-box")
        if (container.scrollTop < container.scrollHeight - container.clientHeight - 50) {
            setAutoScroll(false);
        }
        else {
            setAutoScroll(true);
        }
    }

    const scrollToAnswer = (id) => {
        setSelectedQuestionId(id);
        const answerContainer = document.getElementById(`answer-${id}`);
        if (answerContainer) {
            answerContainer.scrollIntoView({
                behavior: "smooth",
                block: "start",
            });
        }
    };

    function replaceImagesWithDivsAndStore(htmlContent) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlContent, 'text/html');
        const images = Array.from(doc.querySelectorAll('img'));

        const imgTags = [];

        images.forEach((img) => {
            const div = document.createElement('div');
            div.style.width = img.getAttribute('width') + 'px';
            div.style.height = img.getAttribute('height') + 'px';
            div.style.border = '1px solid black';
            div.className = 'imageDiv'
            imgTags.push(img.outerHTML);
            img.parentNode.replaceChild(div, img);
        });
        return { modifiedHTML: doc.documentElement.outerHTML, imgTags };
    }

    // Function to restore <img> tags back to their original positions
    function restoreImages(htmlContent, imgTags) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlContent, 'text/html');
        const divs = doc.querySelectorAll('.imageDiv');

        divs.forEach((div, index) => {
            if (div.innerHTML === '' && imgTags[index]) {
                const img = document.createElement('img');
                const parser = new DOMParser();
                const imgDoc = parser.parseFromString(imgTags[index], 'text/html');
                const imgElement = imgDoc.querySelector('img');
                img.src = imgElement.getAttribute('src');
                img.width = imgElement.getAttribute('width');
                img.height = imgElement.getAttribute('height');
                div.parentNode.insertBefore(img, div);
                div.remove();
            }
        });
        return doc.documentElement.outerHTML;
    }

    //sending data
    const handleSendMessage = (message) => {
        setVoiceInput(false);
        // console.log(message, currentQuestion);
        let webSocket;
        let difficult_words = textareaContent
        let context = currentContext
        setDisableTextArea(false);
        setTranslate(false);
        setShowDownload(true);
        const newMessages = [...messages, { text: message, fromUser: true, index: 0, id: nanoid(24) }];
        if (currentQuestion.trim() === "") {
            setErrorMessage("text cannot be empty");
            setLoading(false);
        } else {
            setCurrentQuestion('');
            setLoading(true);
            setErrorMessage("");

            setMessages(newMessages);
            let first = true;
            const sp = new URLSearchParams();
            sp.set('sender', sender); // TODO: handle collisions
            sp.set('message', message)
            sp.set('grade', `class${selectedGrade}`)
            sp.set('subject', selectedSubject.toLowerCase())
            sp.set('topic', selectedTopic)
            sp.set('board', selectedBoard)
            sp.set('difficult', difficult_words)
            sp.set('story_context', context)
            sp.set('email', JSON.parse(sessionStorage.getItem("userDetails"))['user_email']);
            if (selectedFiles) {
                sp.set('images', 'True')
            }
            const url = askQuestionTaraURL();
            const fullUrl = `${url}?${sp.toString()}`;
            webSocket = new WebSocket(fullUrl);

            // Event listener for when the connection is opened
            webSocket.addEventListener('open', (event) => {
                console.log('WebSocket connection opened:', event);
                if (selectedFiles) {
                    webSocket.send(JSON.stringify({ 'images': [base64Data] }));
                }
            });
            setInterval(() => {
                window.renderMathInElement(document.body, {
                    delimiters: [
                        { left: "$$", right: "$$", display: true },
                        { left: "$", right: "$", display: false },
                        { left: "\\(", right: "\\)", display: false },
                        { left: "\\[", right: "\\]", display: true }
                    ]
                });
            }, 10);
            // Event listener for when a message is received from the server
            webSocket.addEventListener('message', (event) => {
                setLoading(false);
                // Handle the received message here
                const data = JSON.parse(event.data);
                const numberOfImages = data[0]?.noofimages;
                if (data[0] && numberOfImages) {
                    setImageFlag(numberOfImages);
                }
                if (data[0] && data[0].text) {
                    setEnglishAnswer(data[0].text);
                    if (translate) {
                        setCurrentAnswer(translatedText);
                    } else {
                        setCurrentAnswer(data[0].text);
                    }

                    /** @type {string} */
                    let text = data[0].text;
                    let images = data[0].images ?? [];
                    setImageFlag(null);
                    while (text.indexOf('\0') !== -1) {
                        const start = text.indexOf('data:image/');
                        const end = text.indexOf('\0\0');
                        if (start !== -1 && end !== -1) {
                            images.push(text.substring(start, end + 1));
                            text = text.substring(0, start) + text.substring(end + 2);
                        }
                    }
                    data[0].images = images;
                    data[0].text = text;
                }
                setTimeout(() => setMessages((messages) => {
                    let m;
                    if (!(data[0] && data[0].text)) return messages;
                    if (!first) {
                        m = messages.slice(0, -1);
                    } else {
                        first = false;
                        m = messages;
                    }
                    const msg = { text: data[0].text, fromUser: false, images: data[0].images ?? [] }
                    return [...m, msg];
                }), 250);
            });

            // Event listener for when the connection is closed
            webSocket.addEventListener('close', (event) => {
                console.log('WebSocket connection closed:', event);
                setDisableTextArea(true);
                setTranslatedText(null);
                setTranslate(true);
                setTranslationLanguage('hi');
            });

            // Clean up the WebSocket connection when the component is unmounted
            return () => {
                webSocket.close();
            };

        }
    };

    const fetchChatHistory = async () => {
        console.log("Fetching Chat History");
        try {
            setLoading(true);
            const url = chatHistoryReadingCompURL();
            const params = new URLSearchParams({
                "email": JSON.parse(sessionStorage.getItem("userDetails"))['user_email']
            });
            const response = await axios.get(`${url}?${params.toString()}`);
            setChatHistory(response.data.chat_history);
            setDisableTextArea(false);
            setLoading(false);
        } catch (error) {
            setLoading(false);
            console.error("Error fetching chat history", error);
        }
    };

    // Function to go to the next session
    const handleNextClick = () => {
        if (selectedSessionIndex < chatHistory.length - 1) {
            const newIndex = selectedSessionIndex + 1;  // Calculate the new index
            setSelectedSessionIndex(newIndex);  // Update the index state
            setSelectedSession(chatHistory[newIndex]);  // Set the session using the new index
        }
    };

    // Function to go to the previous session
    const handlePreviousClick = () => {
        if (selectedSessionIndex > 0) {
            const newIndex = selectedSessionIndex - 1;  // Calculate the new index
            setSelectedSessionIndex(newIndex);  // Update the index state
            setSelectedSession(chatHistory[newIndex]);  // Set the session using the new index
        }
    };

    // Function to handle session selection from the popup
    const handleSessionClick = (session) => {
        // Find the index of the clicked session
        const sessionIndex = chatHistory.findIndex((s) => s.session_id === session.session_id);

        if (sessionIndex !== -1) {
            // First, update the selected session index
            setSelectedSessionIndex(sessionIndex);

            // Then, update the selected session based on the new index
            setSelectedSession(chatHistory[sessionIndex]);
        }
        setShowChatHistoryPopup(false);
        console.log("Session index:", sessionIndex);
    };

    const handleSendMessageSpeech = (message) => {
        console.log(message);
        let webSocket;
        let difficult_words = textareaContent;
        let context = currentContext;
        setDisableTextArea(false);
        setTranslate(false);
        const newMessages = [...messages, { text: message, fromUser: true, index: 0, id: nanoid(24) }];
        if (message.trim() === "") {
            setErrorMessage("text cannot be empty");
            setLoading(false);
        } else {
            setCurrentQuestion('');
            setLoading(true);
            setErrorMessage("");

            setMessages(newMessages);
            let first = true;
            const sp = new URLSearchParams();
            sp.set('sender', sender); // TODO: handle collisions
            sp.set('message', message)
            sp.set('grade', `class${selectedGrade}`)
            sp.set('subject', selectedSubject.toLowerCase())
            sp.set('topic', selectedTopic)
            sp.set('board', selectedBoard)
            sp.set('difficult', difficult_words)
            sp.set('story_context', context)
            sp.set('email', JSON.parse(sessionStorage.getItem("userDetails"))['user_email']);
            if (selectedFiles) {
                sp.set('images', 'True')
            }
            
            const url = askQuestionTaraURL();
            const fullUrl = `${url}?${sp.toString()}`;
            webSocket = new WebSocket(fullUrl);


            // Event listener for when the connection is opened
            webSocket.addEventListener('open', (event) => {
                console.log('WebSocket connection opened:', event);
                if (selectedFiles) {
                    webSocket.send(JSON.stringify({ 'images': [base64Data] }));
                }
            });
            setInterval(() => {
                window.renderMathInElement(document.body, {
                    delimiters: [
                        { left: "$$", right: "$$", display: true },
                        { left: "$", right: "$", display: false },
                        { left: "\\(", right: "\\)", display: false },
                        { left: "\\[", right: "\\]", display: true }
                    ]
                });
            }, 10);
            // Event listener for when a message is received from the server
            webSocket.addEventListener('message', (event) => {
                setLoading(false);
                // Handle the received message here
                const data = JSON.parse(event.data);
                const numberOfImages = data[0]?.noofimages;
                if (data[0] && numberOfImages) {
                    setImageFlag(numberOfImages);
                }
                if (data[0] && data[0].text) {
                    setEnglishAnswer(data[0].text);
                    if (translate) {
                        setCurrentAnswer(translatedText);
                    } else {
                        setCurrentAnswer(data[0].text);
                    }

                    /** @type {string} */
                    let text = data[0].text;
                    let images = data[0].images ?? [];
                    setImageFlag(null);
                    while (text.indexOf('\0') !== -1) {
                        const start = text.indexOf('data:image/');
                        const end = text.indexOf('\0\0');
                        if (start !== -1 && end !== -1) {
                            images.push(text.substring(start, end + 1));
                            text = text.substring(0, start) + text.substring(end + 2);
                        }
                    }
                    data[0].images = images;
                    data[0].text = text;
                }
                setTimeout(() => setMessages((messages) => {
                    let m;
                    if (!(data[0] && data[0].text)) return messages;
                    if (!first) {
                        m = messages.slice(0, -1);
                    } else {
                        first = false;
                        m = messages;
                    }
                    const msg = { text: data[0].text, fromUser: false, images: data[0].images ?? [] }
                    return [...m, msg];
                }), 250);
            });

            // Event listener for when the connection is closed
            webSocket.addEventListener('close', (event) => {
                console.log('WebSocket connection closed:', event);
                setDisableTextArea(true);
                setTranslatedText(null);
                setTranslate(true);
                setTranslationLanguage('hi');
            });

            // Clean up the WebSocket connection when the component is unmounted
            return () => {
                webSocket.close();
            };

        }
    };

    const storyGetOutput = (message, difficult_words, context) => {
        setVoiceInput(false);
        console.log(message, difficult_words, context);
        let webSocket;
        setDisableTextArea(false);
        setTranslate(false);
        const newMessages = [...messages, { text: message, fromUser: true, index: 0, id: nanoid(24) }];
        if (message.trim() === "") {
            setErrorMessage("text cannot be empty");
            setLoading(false);
        } else {
            setCurrentQuestion('');
            setLoading(true);
            setErrorMessage("");

            setMessages(newMessages);
            let first = true;
            const sp = new URLSearchParams();
            sp.set('sender', sender); // TODO: handle collisions
            sp.set('message', message)
            sp.set('grade', `class${selectedGrade}`)
            sp.set('subject', selectedSubject.toLowerCase())
            sp.set('topic', selectedTopic)
            sp.set('board', selectedBoard)
            sp.set('difficult', difficult_words)
            sp.set('story_context', context)
            sp.set('email', JSON.parse(sessionStorage.getItem("userDetails"))['user_email']);
            if (selectedFiles) {
                sp.set('images', 'True')
            }
            const url = generateStoryTaraURL();
            const fullUrl = `${url}?${sp.toString()}`;
            webSocket = new WebSocket(fullUrl);

            // Event listener for when the connection is opened
            webSocket.addEventListener('open', (event) => {
                console.log('WebSocket connection opened:', event);
                if (selectedFiles) {
                    webSocket.send(JSON.stringify({ 'images': [base64Data] }));
                }
            });
            setInterval(() => {
                window.renderMathInElement(document.body, {
                    delimiters: [
                        { left: "$$", right: "$$", display: true },
                        { left: "$", right: "$", display: false },
                        { left: "\\(", right: "\\)", display: false },
                        { left: "\\[", right: "\\]", display: true }
                    ]
                });
            }, 10);
            // Event listener for when a message is received from the server
            webSocket.addEventListener('message', (event) => {
                setLoading(false);
                // Handle the received message here
                const data = JSON.parse(event.data);
                const numberOfImages = data[0]?.noofimages;
                if (data[0] && numberOfImages) {
                    setImageFlag(numberOfImages);
                }
                if (data[0] && data[0].text) {
                    setEnglishAnswer(data[0].text);
                    if (translate) {
                        setCurrentAnswer(translatedText);
                    } else {
                        setCurrentAnswer(data[0].text);
                    }

                    /** @type {string} */
                    let text = data[0].text;
                    let images = data[0].images ?? [];
                    setImageFlag(null);
                    while (text.indexOf('\0') !== -1) {
                        const start = text.indexOf('data:image/');
                        const end = text.indexOf('\0\0');
                        if (start !== -1 && end !== -1) {
                            images.push(text.substring(start, end + 1));
                            text = text.substring(0, start) + text.substring(end + 2);
                        }
                    }
                    data[0].images = images;
                    data[0].text = text;
                }
                setTimeout(() => setMessages((messages) => {
                    let m;
                    if (!(data[0] && data[0].text)) return messages;
                    if (!first) {
                        m = messages.slice(0, -1);
                    } else {
                        first = false;
                        m = messages;
                    }
                    const msg = { text: data[0].text, fromUser: false, images: data[0].images ?? [] }
                    return [...m, msg];
                }), 250);
            });

            // Event listener for when the connection is closed
            webSocket.addEventListener('close', (event) => {
                console.log('WebSocket connection closed:', event);
                setDisableTextArea(true);
                setTranslatedText(null);
                setTranslate(true);
                setTranslationLanguage('hi');
            });

            // Clean up the WebSocket connection when the component is unmounted
            return () => {
                webSocket.close();
            };

        }
    };


    const SummarizeButton = (props) => {
        return (
            <div className="flex justify-start my-2 ml-5">
                <button
                    aria-label={'Summarize'}
                    className="border-2 border-black text-black px-4 py-2 rounded"
                    onClick={() => summarize(props)}
                >
                    {'Summarize'}
                </button>
            </div>
        )
    }

    function summarize({ setMessages, sender }) {
        setMessages(m => [...m, { text: "Summarize this chapter.", fromUser: true }])
        let first = true;
        let difficult_words = textareaContent
        let context = currentContext
        setDisableTextArea(false);
        setTranslate(false);
        const on_message = (ev) => setTimeout(() => setMessages((messages) => {
            const data = JSON.parse(ev.data);
            let m;
            if (!(data[0] && data[0].text)) return messages;
            if (!first) {
                m = messages.slice(0, -1);
            } else {
                first = false;
                m = messages;
            }

            const msg = { text: data[0].text, fromUser: false }
            return [...m, msg];
        }), 250);
        const sp = new URLSearchParams()
        sp.set(`sender`, sender);
        sp.set(`grade`, `class${selectedGrade}`)
        sp.set(`subject`, selectedSubject.toLowerCase());
        sp.set(`topic`, selectedTopic);
        sp.set(`board`, selectedBoard);
        sp.set(`difficult`, difficult_words);
        sp.set(`story_context`, context);
        const url = new URL(`wss://edu.demo.krtrimaiq.ai/tara/chat_tokens_qa?`);
        url.search = sp.toString()
        const ws = new WebSocket(url);
        ws.onmessage = on_message;

        // Event listener for when the connection is closed
        ws.addEventListener('close', (event) => {
            console.log('WebSocket connection closed:', event);
            setDisableTextArea(true);
            setTranslate(true);
        });
    }

    function getSubjectOptions(grade) {
        return (tutorSubject.filter(subject => (readingCompGrade.find(item => item.code === grade).subjects).includes(subject.code)));

    }

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        setSelectedFiles(file);

        const reader = new FileReader();
        reader.onload = () => {
            const base64String = reader.result.split(",")[1]; // Extract the Base64 data part
            setBase64Data(base64String);
        };
        reader.readAsDataURL(file);
    };

    const ImageUpload = ({ accept, onChange, multiple }) => {
        const fileInputRef = useRef(null);
        return (
            <div>
                <div className="inline-flex">
                    <button
                        type="button"
                        className="p-2 bg-white border-2 border-blue font-bold text-lg text-blue rounded-lg hover:bg-light-purple"
                        onClick={() => fileInputRef.current.click()}
                    >
                        <img
                            src={cloud}
                            alt=""
                            width={"100px"}
                            height={"100px"}
                            className="text-blue"
                        />
                    </button>
                    <input
                        type="file"
                        name="file_upload"
                        className="hidden inset-0 opacity-0 cursor-pointer"
                        ref={fileInputRef}
                        accept={accept}
                        onChange={onChange}
                        multiple={multiple}
                    />
                </div>
            </div>
        );
    };



    const [listening, setListening] = useState(false);
    const [transcription, setTranscription] = useState('');
    const handleStartListening = () => {
        setVoiceInput(true);
        const recognition = new window.webkitSpeechRecognition();
        // recognition.lang = 'en-US';
        if (selectedSubject == 'English') {
            recognition.lang = 'en-US';
        }
        else if (selectedSubject == 'Hindi') {
            recognition.lang = 'hi-IN';
        }
        recognition.start();

        recognition.onstart = () => {
            setListening(true);
        };

        recognition.onresult = (event) => {
            const transcript = event.results[0][0].transcript;
            // console.log(transcript);
            setModalIsOpen(true);
            latestTranscriptRef.current = transcript;

        };

        recognition.onend = () => {
            setListening(false);
            closeModal();
            setTimeout(function () {
                const transcript = latestTranscriptRef.current;
                setCurrentQuestion(transcript);
                handleSendMessageSpeech(transcript);
            }, 1000);
        };

        recognition.onerror = (event) => {
            console.error('Speech recognition error detected: ', event.error);
            setListening(false);
        };
    };

    const openDialog = () => {
        setModalIsOpen(true);
        handleStartListening();

    };
    const [modalIsOpen, setModalIsOpen] = useState(false);

    const closeModal = () => {
        setModalIsOpen(false);
        // setDisplayQuestionInput(false);
        // console.log(currentQuestion);
        // handleSendMessage(currentQuestion, stream);
    };

    const [selectedText, setSelectedText] = useState('');
    const [textToTrans, setTextToTrans] = useState('');
    const [selectedWordIdx, setSelectedWordIdx] = useState(null);
    const [highlightedText, setHighlightedText] = useState(englishAnswer);
    const [translatedWords, setTranslatedWords] = useState('');
    const [buttonVisible, setButtonVisible] = useState(false);
    const [buttonPosition, setButtonPosition] = useState({ top: 0, left: 0 });
    const [imgLoading, setImgLoading] = useState(false);
    const containerRef = useRef(null);
    const isTextareaEmpty = textareaContent.trim() === "";
    const [isHovered, setIsHovered] = useState(false);
    const [dropdownVisible, setDropdownVisible] = useState(false);
    const [imgDropdown, setImgDropdown] = useState(false);
    const [generatedImageUrl, setGeneratedImageUrl] = useState('');
    const [pronounce, setPronounce] = useState('');
    const closeTimeoutRef = useRef(null);
    const [popupStyle, setPopupStyle] = useState({});
    const [imgTheme, setImgTheme] = useState('dark');
    const popupRef = useRef(null);

    const handleSelection = () => {
        if (document.getSelection().focusNode && document.getSelection().focusNode.parentElement.closest('div')?.classList.contains('bot-response')) {
            const text = document.getSelection().toString();
            setSelectedText(text);
            setTextToTrans(text);

            // Calculate position based on the selection
            const selection = window.getSelection();
            if (selection.rangeCount > 0) {
                const range = selection.getRangeAt(0).getBoundingClientRect();
                // console.log(range.top + window.scrollY + range.height / 2);
                // console.log(range.right + window.scrollX + 10);

                setButtonPosition({
                    top: range.top + window.scrollY + range.height / 2, // Adjust position to be centered vertically
                    left: range.right + window.scrollX + 10, // Position the button slightly to the right of the selection
                });
                // console.log(selection);
                // console.log(!!text);
                setButtonVisible(!!text); // Show button only if text is selected
                const wordIdx = getWordIndex(selection);
                setSelectedWordIdx(wordIdx);
            }
        } else {
            setSelectedText('');
            setButtonVisible(false);
        }
    };

    const getWordIndex = (selection) => {
        const textContent = selection.anchorNode.textContent;
        const words = textContent.split(' ');
        const anchorOffset = selection.anchorOffset;

        let cumulativeLength = 0;
        for (let i = 0; i < words.length; i++) {
            cumulativeLength += words[i].length + (i === 0 ? 0 : 1); // Add 1 for the space between words
            if (anchorOffset < cumulativeLength) {
                return i;
            }
        }
        return -1;
    };

    const handleReadAloud = () => {
        if (selectedText) {
            // console.log(selectedText);

            window.speechSynthesis.cancel();
            if (!window.speechSynthesis) {
                console.error("Speech synthesis not supported.");
                return;
            }
            const utterance = new SpeechSynthesisUtterance(selectedText);

            const isHindi = /[\u0900-\u097F]/.test(selectedText); // Check for Hindi characters


            const voices = window.speechSynthesis.getVoices();
            const hindiVoices = voices.filter(voice => voice.lang === "hi-IN");
            let selectedVoice;

            if (isHindi) {
                utterance.lang = "hi-IN";
                const hindiVoices = voices.filter(voice => voice.lang === "hi-IN");
                selectedVoice = hindiVoices.find(voice => voice.name.includes("Microsoft Swara Online (Natural) - Hindi (India)")) || hindiVoices[0];
            } else {

                utterance.lang = "en-US";
                const englishVoices = voices.filter(voice => voice.lang === "en-US" && voice.gender === "male");
                selectedVoice = englishVoices.find(voice => voice.name.includes("Microsoft David Desktop - English (United States)")) || englishVoices[0];
            }

            if (selectedVoice) {
                utterance.voice = selectedVoice;
            } else {
                console.warn("No appropriate voice found, using default voice.");
            }

            window.speechSynthesis.speak(utterance);
        }
    };

    useEffect(() => {
        document.addEventListener('mouseup', handleSelection);
        return () => {
            document.removeEventListener('mouseup', handleSelection);
        };
    }, []);

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const handleClickOutside = (event) => {
        if (containerRef.current && !containerRef.current.contains(event.target)) {
            setButtonVisible(false);
            setGeneratedImageUrl('');
            setTranslatedWords('');
            // setTranslationLanguage('hi');
            setDropdownVisible(false);
            setImgDropdown(false);
            setPronounce('');
        }
    };


    const handleTranslateClick = (e) => {
        // e.stopPropagation();
        setDropdownVisible(!dropdownVisible);
    };

    const handleMouseEnter = () => {
        setIsHovered(true);
        if (closeTimeoutRef.current) {
            clearTimeout(closeTimeoutRef.current);
        }
        adjustPopupPosition();
    };

    const handleMouseLeave = () => {
        closeTimeoutRef.current = setTimeout(() => {
            setIsHovered(false);
            // setDropdownVisible(false);
            setTranslationLanguage('hi');
        }, 300); // Delay closing by 300ms
    };


    const handleLanguageTranslationWord = (id, word, msg, lang) => {
        // console.log(id,word,msg,translationLanguage)
        const { modifiedHTML, imgTags } = replaceImagesWithDivsAndStore(msg);

        languageTranslationURL({
            text: word,
            target_lang: lang.value,
        }).then((response) => {
            setTranslatedWords(response.data['translated_text']);
        }).catch(error => {
            alert("Can you please try again in sometime");
        }).finally(
            setTextToTrans(''),
            setDropdownVisible(false)
        );
    };

    const handleSyllablePronounce = async (word) => {
        setLoading(true);
        try {
            const params = new URLSearchParams({
                "sender": sender,
                "pronounce_word": word
            });
            const url = pronounceTaraURL();
            const response = await axios.post(`${url}?${params.toString()}`);
            if (response.status === 200) {
                setPronounce(response.data.text);
                readAloudpopup(response.data.text);
                setShowPopup(true);
                setPronounceOutput(response.data.syllables)
            } else {
                console.error('Failed to generate Syllables', response.data.text);
            }
        } catch (error) {
            console.error('An error occurred while generating Syllable', error);
        } finally {
            setLoading(false);
            setTextToTrans('');
            setImgDropdown(false);
            setGeneratedImageUrl('');
        }
    }

    const handleGenerateImg = async (word, theme) => {
        setImgLoading(true);
        try {
            const data = {
                "sender": sender,
                "message": word,
                "theme": theme.value
            };

            const url = generateImgURL(); // get only the URL

            const response = await axios.post(url, data); // send URL and payload

            if (response.status === 200) {
                setGeneratedImageUrl(response.data.image_url);
            } else {
                console.error('Failed to generate image', response.data.image_url);
            }
        } catch (error) {
            console.error('An error occurred while generating the image', error);
        } finally {
            setImgLoading(false);
            setTextToTrans('');
            setImgDropdown(false);
            setPronounce('');
        }
    };

    const handleGenerateQue = () => {
        setMessages(m => [...m, { text: "Generate Questions for the sentence", fromUser: true }])
        let first = true;
        let difficult_words = textareaContent
        let context = currentContext
        setDisableTextArea(false);
        setTranslate(false);
        const on_message = (ev) => setTimeout(() => setMessages((messages) => {
            const data = JSON.parse(ev.data);
            let m;
            if (!(data[0] && data[0].text)) return messages;
            if (!first) {
                m = messages.slice(0, -1);
            } else {
                first = false;
                m = messages;
            }

            const msg = { text: data[0].text, fromUser: false }
            return [...m, msg];
        }), 250);
        const sp = new URLSearchParams()
        sp.set(`sender`, sender);
        sp.set(`message`, selectedText);
        sp.set(`grade`, `class${selectedGrade}`);
        sp.set(`subject`, selectedSubject.toLowerCase());
        sp.set(`topic`, selectedTopic);
        sp.set(`board`, selectedBoard);
        sp.set(`difficult`, difficult_words);
        sp.set(`story_context`, context);
        const url = new URL(`wss://edu.demo.krtrimaiq.ai/tara/generate_questions?`);
        url.search = sp.toString()
        const ws = new WebSocket(url);
        ws.onmessage = on_message;

        // Event listener for when the connection is closed
        ws.addEventListener('close', (event) => {
            console.log('WebSocket connection closed:', event);
            setDisableTextArea(true);
            setTranslate(true);
        });
    };

    const adjustPopupPosition = () => {
        if (popupRef.current) {
            const { innerWidth, innerHeight } = window;
            const { offsetWidth, offsetHeight } = popupRef.current;
            const newTop = Math.min(buttonPosition.top, innerHeight - offsetHeight - 10);
            const newLeft = Math.min(buttonPosition.left, innerWidth - offsetWidth - 10);
            setPopupStyle({
                top: newTop,
                left: newLeft,
                maxWidth: 'calc(33vw - 10px)',  // 1/3 of viewport width with 10px padding
                maxHeight: 'calc(33vh - 10px)', // 1/3 of viewport height with 10px padding
                overflow: 'auto'
            });
        }
    };

    useEffect(() => {
        const updatePopupPosition = () => {
            if (popupRef.current) {
                const { innerWidth, innerHeight } = window;
                const { offsetWidth, offsetHeight } = popupRef.current;
                const newTop = Math.min(buttonPosition.top, innerHeight - offsetHeight - 10);
                const newLeft = Math.min(buttonPosition.left, innerWidth - offsetWidth - 10);
                setPopupStyle({
                    top: newTop,
                    left: newLeft,
                    maxWidth: 'calc(33vw - 10px)',  // 1/3 of viewport width with 10px padding
                    // maxHeight: 'calc(33vh - 10px)', // 1/3 of viewport height with 10px padding
                    height: 'auto',
                    overflow: 'auto'
                });
            }
        };

        updatePopupPosition();
        window.addEventListener('resize', updatePopupPosition);
        return () => window.removeEventListener('resize', updatePopupPosition);
    }, [buttonPosition, isHovered]);

    return (
        <div className="flex gap-4">
            <div ref={containerRef}>
                {info && (
                    <Draggable>
                        <div
                            className={`z-50 absolute w-3/5 h-3/4 bg-white rounded-md shadow-lg overflow-auto p-4 items-center`}>
                            <button
                                className="absolute top-4 right-4 text-black"
                                onClick={(e) => { setInfo() }}
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" width="1.2em" height="1.2em" viewBox="0 0 16 16">
                                    <path fill="currentColor" fill-rule="evenodd" d="M13.5 8a5.5 5.5 0 1 1-11 0a5.5 5.5 0 0 1 11 0M15 8A7 7 0 1 1 1 8a7 7 0 0 1 14 0M6.53 5.47a.75.75 0 0 0-1.06 1.06L6.94 8L5.47 9.47a.75.75 0 1 0 1.06 1.06L8 9.06l1.47 1.47a.75.75 0 1 0 1.06-1.06L9.06 8l1.47-1.47a.75.75 0 1 0-1.06-1.06L8 6.94z" clip-rule="evenodd" />
                                </svg>
                            </button>
                            <div dangerouslySetInnerHTML={{ __html: info }}>
                            </div>
                        </div>
                    </Draggable>)}
                {/* popup modal */}
                {showPopup && (
                    <Draggable>
                        <div className="z-50 absolute flex flex-col justify-between items-center inset-0 m-auto w-fit h-fit bg-white rounded-md shadow-lg border-2 p-4 overflow-hidden">
                            <div className="text-xl text-center p-6 bg-white">
                                {pronounceOutput}
                            </div>
                            {/* Button Row */}
                            <div className="flex gap-4 mt-4">
                                {/* Close button with icon */}
                                <Button
                                    className="px-6 py-2 bg-red-500 text-white rounded hover:bg-red-600 flex items-center"
                                    onClick={() => {
                                        setShowPopup(false);
                                    }}
                                >
                                    Close
                                </Button>
                            </div>
                        </div>
                    </Draggable>

                )}
                {!(generatedImageUrl) && !(translatedWords) && !(pronounce) && (buttonVisible) && (
                    <div
                        ref={popupRef}
                        style={popupStyle}
                        className={`z-50 absolute h-auto flex-col bg-white rounded-md shadow-lg border-2 ${isHovered ? 'p-4' : 'p-2'}`}
                        onMouseEnter={handleMouseEnter}
                        onMouseLeave={handleMouseLeave}
                    >
                        <button
                            className="flex space-x-2 cursor-pointer hover:bg-gray-200 hover:w-full p-2 hover:rounded-lg"
                            onClick={() => {
                                setDropdownVisible(false);
                                setImgDropdown(false);
                                handleReadAloud();
                            }}
                            aria-label="Read Aloud"
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" width="1.25em" height="1.25em" viewBox="0 0 16 16">

                                <path fill="currentColor" d="M10.044 1.498a.75.75 0 0 1 .958-.454c.214.09.001 0 .001 0h.001l.003.001l.005.003l.015.005a2 2 0 0 1 .19.08c.118.056.28.138.47.253c.379.23.876.596 1.37 1.143C14.057 3.636 15 5.44 15 8.249a.75.75 0 0 1-1.5 0c0-2.44-.807-3.885-1.556-4.715a4.7 4.7 0 0 0-1.036-.865a3 3 0 0 0-.401-.209l-.014-.005a.75.75 0 0 1-.45-.957M7.198 3.475a.75.75 0 0 0-1.395 0l-3.75 9.5a.75.75 0 0 0 1.395.55l.898-2.275h4.308l.898 2.275a.75.75 0 1 0 1.396-.55zm.864 6.275H4.938L6.5 5.793zm2.668-6.076a.75.75 0 0 0-.962 1.15l.006.006l.034.03q.049.045.139.136c.12.123.28.304.44.53c.327.463.613 1.063.613 1.724a.75.75 0 0 0 1.5 0c0-1.088-.464-1.989-.887-2.588a6 6 0 0 0-.853-.962l-.02-.017l-.006-.005l-.002-.002zm-.962 1.15l.001.002Z" />
                            </svg>
                            {isHovered && <span className="ml-2 text-gray-800">Read Aloud</span>}
                        </button>

                        <button
                            className="flex space-x-2 cursor-pointer hover:bg-gray-200 hover:w-full p-2 hover:rounded-lg"
                            onClick={() => {
                                handleTranslateClick();
                                setImgDropdown(false);
                            }}
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" width="1.25em" height="1.25em" viewBox="0 0 20 20">
                                <path fill="currentColor" d="M4.178 3.204a4.9 4.9 0 0 1 2.806 0h.001c1.028.305 1.602.935 1.885 1.638c.255.634.255 1.288.254 1.655v4.753a.75.75 0 0 1-1.5 0v-.005q-.27.148-.568.28c-.745.332-1.702.603-2.63.408c-1.203-.253-2.011-1.154-2.303-2.152c-.29-.996-.087-2.18.839-2.958c1.008-.849 2.165-1.052 3.175-1.01c.53.022 1.034.113 1.474.218a2.1 2.1 0 0 0-.133-.629c-.117-.292-.344-.589-.918-.759a3.42 3.42 0 0 0-2.662.302l-.028.017l-.002.002a.75.75 0 0 1-.852-1.235l.002-.001l.004-.003l.007-.005l.022-.014q.026-.018.068-.043q.085-.054.234-.13a5 5 0 0 1 .825-.329m1.897 4.108c-.763-.032-1.51.123-2.148.659c-.39.328-.52.856-.364 1.39c.155.531.573.978 1.17 1.104c.475.1 1.081-.029 1.714-.31a7 7 0 0 0 1.177-.681V7.585c-.465-.13-.996-.25-1.55-.273m7.907-1.263a.75.75 0 0 1 .435.967c-.059.154-.12.335-.18.522q.729-.113 1.453-.271a.75.75 0 0 1 .318 1.466c-.721.156-1.46.288-2.207.38q-.15.637-.248 1.181q.591-.089 1.14-.073a.75.75 0 0 1 1.473.204v.04c1.187.376 2.093 1.16 2.541 2.177c.402.91.403 1.958-.083 2.929c-.483.964-1.413 1.793-2.773 2.37a.75.75 0 0 1-.585-1.381c1.116-.474 1.73-1.089 2.016-1.66a1.9 1.9 0 0 0 .053-1.652c-.216-.489-.666-.956-1.325-1.243a7.06 7.06 0 0 1-1.816 3.506c.076.149.15.3.211.444a.75.75 0 1 1-1.38.59l-.028-.067a4.4 4.4 0 0 1-1.345.556c-.667.143-1.45.089-1.993-.464c-.799-.814-.83-2.135-.318-3.263c.442-.972 1.305-1.89 2.615-2.514q.096-.709.278-1.554q-.764.03-1.532-.018a.75.75 0 0 1 .094-1.497c.603.038 1.21.033 1.82-.006c.117-.404.26-.872.399-1.234a.75.75 0 0 1 .967-.435M11.833 12.6c-.564.412-.925.885-1.126 1.327c-.358.789-.191 1.374.023 1.593c.032.032.189.137.609.048c.287-.062.632-.206.992-.443a6 6 0 0 1-.344-1.087a7.3 7.3 0 0 1-.154-1.438m1.688 1.394a5.65 5.65 0 0 0 1.017-2.278c-.365 0-.76.044-1.185.144c-.053.804 0 1.398.1 1.863q.031.141.068.27" />
                            </svg>
                            {isHovered && (
                                <>
                                    <span>Translate</span>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="1.25em" height="1.25em" viewBox="0 0 24 24">
                                        <path fill="currentColor" d="M10 17l5-5-5-5v10z" /> {/* Right arrow icon */}
                                    </svg>
                                </>
                            )}
                        </button>

                        <button
                            className="flex space-x-2 cursor-pointer hover:bg-gray-200 hover:w-full p-2 hover:rounded-lg"
                            onClick={() => {
                                handleSyllablePronounce(textToTrans);
                                setImgDropdown(false);
                            }}
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" width="1.3em" height="1.3em" viewBox="0 0 48 48"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4" d="M4 24s6-9 10-9s8 2 10 2s6-2 10-2s10 9 10 9s-10 10-20 10S4 24 4 24m0 0h40" /></svg>
                            {isHovered && (<span>Pronounce</span>)}
                        </button>

                        <button
                            className="flex space-x-2 cursor-pointer hover:bg-gray-200 hover:w-full p-2 hover:rounded-lg"
                            onClick={() => {
                                setImgDropdown(true);
                                setDropdownVisible(false);
                            }}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="1.25em" height="1.25em" viewBox="0 0 256 256">
                                <path fill="currentColor" d="M144 96a16 16 0 1 1 16 16a16 16 0 0 1-16-16m92-40v144a20 20 0 0 1-20 20H40a20 20 0 0 1-20-20V56a20 20 0 0 1 20-20h176a20 20 0 0 1 20 20M44 60v79.72l33.86-33.86a20 20 0 0 1 28.28 0L147.31 147l17.18-17.17a20 20 0 0 1 28.28 0L212 149.09V60Zm0 136h118.34L92 125.66l-48 48Zm168 0v-13l-33.37-33.37L164.28 164l32 32Z" />
                            </svg>
                            {isHovered && <span>Generate Image</span>}
                        </button>

                        <button
                            className="flex space-x-2 cursor-pointer hover:bg-gray-200 hover:w-full p-2 hover:rounded-lg"
                            onClick={() => {
                                handleGenerateQue(); // give the 
                                setDropdownVisible(false);
                                setImgDropdown(false);
                            }}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="1.3em" height="1.3em" viewBox="0 0 26 26">
                                <path fill="currentColor" d="M13 0C5.925 0 0 5.08 0 11.5c0 3.03 1.359 5.748 3.5 7.781a6.733 6.733 0 0 1-1.094 1.875A16.48 16.48 0 0 1 .375 23.22A1 1 0 0 0 1 25c2.215 0 3.808-.025 5.25-.406c1.29-.342 2.399-1.058 3.531-2.063c1.03.247 2.093.469 3.219.469c7.075 0 13-5.08 13-11.5S20.075 0 13 0m0 2c6.125 0 11 4.32 11 9.5S19.125 21 13 21c-1.089 0-2.22-.188-3.25-.469a1 1 0 0 0-.938.25c-1.125 1.079-1.954 1.582-3.062 1.875c-.51.135-1.494.103-2.188.157c.14-.158.271-.242.407-.407c.786-.96 1.503-1.975 1.719-3.125a1 1 0 0 0-.344-.937C3.249 16.614 2 14.189 2 11.5C2 6.32 6.875 2 13 2m-1.906 3.906a1 1 0 0 0-.469.25l-1.5 1.407l1.344 1.468l1.187-1.125h2.406L15 8.97v1.469l-2.563 1.718A1 1 0 0 0 12 13v2h2v-1.438l2.563-1.718A1 1 0 0 0 17 11V8.594a1 1 0 0 0-.25-.656l-1.5-1.688a1 1 0 0 0-.75-.344h-3.188a1 1 0 0 0-.218 0M12 16v2h2v-2z" />
                            </svg>
                            {isHovered && <span>Generate Questions</span>}
                        </button>
                    </div>
                )}
                {(dropdownVisible) && (
                    <div
                        style={{ top: popupStyle.top - 10 + "px", left: popupStyle.left - 120 + "px", height: '200px', overflowY: 'scroll' }}
                        className="absolute left-full top-0 mt-2 ml-2 flex flex-col space-y-2 bg-white rounded-md shadow-lg border-2 z-50 p-2"
                    // onClick={(e) => e.stopPropagation()}
                    >
                        {translationLanguages.map((language) => (
                            <div className="cursor-pointer hover:bg-[#23479F] hover:text-[#ffffff] rounded p-2 border-1" key={language.label} onClick={() => {
                                handleTranslationLanguageSelect(language);
                                handleLanguageTranslationWord(selectedWordIdx, textToTrans, englishAnswer, language);
                            }}>
                                {language?.label}
                            </div>
                        ))}
                        {/* <Button
                            onClick={() => {
                                handleLanguageTranslationWord(selectedWordIdx, textToTrans, englishAnswer);
                            }}
                        >
                            Translate
                        </Button>
                        <SimpleDropdown
                            defaultValue={translationLanguages[0]}
                            onSelect={handleTranslationLanguageSelect}
                            options={translationLanguages}
                        /> */}
                    </div>
                )}
                {(imgDropdown) && (
                    <div
                        style={{ top: popupStyle.top - 10 + "px", left: popupStyle.left - 120 + "px", height: '200px', overflowY: 'scroll' }}
                        className="absolute left-full top-0 mt-2 ml-2 flex flex-col space-y-2 bg-white rounded-md shadow-lg border-2 z-50 p-2"
                    // onClick={(e) => e.stopPropagation()}
                    >
                        {imgThemes.map((themes) => (
                            <div className="cursor-pointer hover:bg-[#23479F] hover:text-[#ffffff] rounded p-2 border-1" key={themes.label} onClick={() => {
                                handleGenerateImg(textToTrans, themes);
                            }}>
                                {themes?.label}
                            </div>
                        ))}
                    </div>
                )}
                {(translatedWords) && (
                    <Draggable>
                        <div className={`z-50  absolute  top-0 right-0 w-1/3 max-w-1/3 h-1/3 max-h-1/3 bg-white rounded-md shadow-lg border-2  overflow-auto`}>
                            <div className="bg-blue p-2 h-10 flex relative">
                                <div className="bg-white px-4 py-2 tracking-wider leading-4 hover:bg-[#23479F] rounded-full absolute top-1/2 transform -translate-y-1/2"
                                    onClick={() => {
                                        readAloudpopup(translatedWords);
                                    }}
                                >
                                    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 16 16">
                                        <path fill="currentColor" d="M10.044 1.498a.75.75 0 0 1 .958-.454c.214.09.001 0 .001 0h.001l.003.001l.005.003l.015.005a2 2 0 0 1 .19.08c.118.056.28.138.47.253c.379.23.876.596 1.37 1.143C14.057 3.636 15 5.44 15 8.249a.75.75 0 0 1-1.5 0c0-2.44-.807-3.885-1.556-4.715a4.7 4.7 0 0 0-1.036-.865a3 3 0 0 0-.401-.209l-.014-.005a.75.75 0 0 1-.45-.957M7.198 3.475a.75.75 0 0 0-1.395 0l-3.75 9.5a.75.75 0 0 0 1.395.55l.898-2.275h4.308l.898 2.275a.75.75 0 1 0 1.396-.55zm.864 6.275H4.938L6.5 5.793zm2.668-6.076a.75.75 0 0 0-.962 1.15l.006.006l.034.03q.049.045.139.136c.12.123.28.304.44.53c.327.463.613 1.063.613 1.724a.75.75 0 0 0 1.5 0c0-1.088-.464-1.989-.887-2.588a6 6 0 0 0-.853-.962l-.02-.017l-.006-.005l-.002-.002zm-.962 1.15l.001.002Z" />
                                    </svg>
                                </div>
                            </div>

                            <div className={`p-2`}>
                                {translatedWords}
                            </div>
                        </div>
                    </Draggable>
                )
                }
                {(imgLoading) && (
                    <Draggable>
                        <div
                            className={`z-50 absolute flex justify-center items-center inset-0 m-auto w-1/3 h-1/3 bg-white rounded-md shadow-lg space-y-2 border-2 p-4`}>
                            <Spinner />
                        </div>
                    </Draggable>
                )}
                {!(imgLoading) && (generatedImageUrl) && (
                    <Draggable>
                        <div
                            className={`z-50 absolute flex justify-center items-center inset-0 m-auto w-1/3 h-1/3 bg-white rounded-md shadow-lg space-y-2 border-2 p-4 overflow-hidden`}>
                            <div dangerouslySetInnerHTML={{ __html: generatedImageUrl }} >{/* class="select-none" should be from backend */}
                            </div>
                        </div>
                    </Draggable>
                )}
            </div>
            <Modal
                isOpen={modalIsOpen}
                onRequestClose={closeModal}
                className="modal-dialog"
                overlayClassName="modal-overlay"
            >
                <div className="modal-content">
                    <h2 className="modal-title">Voice Search</h2>
                    {/* <p>Speak to search...</p> */}
                    {listening ? 'Listening...' : ' '}
                    {currentQuestion}
                </div>
                <button className="modal-close-btn" onClick={closeModal}>
                    Close
                </button>
            </Modal>
            <div className="secondcardWidth -ml-4">
                <FullCard>
                    <div className="">
                        <div className="flex justify-between items-center mt-2">
                            <div className="subheading text-center">
                                Reading Comprehension
                            </div>
                            <button onClick={refreshSender} className="flex items-center mx-2">
                                <MessageSquarePlus className="mr-2" size={20} />
                            </button>
                            <button type="button" className="text-blue-500" onClick={handleInfo} aria-label="Info">
                                <BadgeHelp className="mr-2" size={20} />
                            </button>
                        </div>
                        {/* ToastContainer will show notifications */}
                        <ToastContainer />
                        <div className="my-8">
                            <div className={"flex justify-center my-8"}>
                                <Button onClick={() => {
                                    fetchChatHistory();
                                    setShowChatHistoryPopup(true);
                                }}>Chat History</Button>
                            </div>
                        </div>
                        <div className="my-8">
                            <div className="text-blue text-lg font-semibold my-2">Select Board</div>
                            <Select dropdownData={tutorBoard} value={selectedBoard}
                                onChange={(e) => handleBoard(e.target.value)}
                            />
                        </div>
                        <div className="my-8">
                            <div className="text-blue text-lg font-semibold my-2">Select Grade</div>
                            <Select dropdownData={readingCompGrade}
                                value={selectedGrade === '13' ? 'Btech 1st year' : selectedGrade}
                                onChange={(e) => handleClassChange(e.target.value)} />
                        </div>

                        <div className="my-8">
                            <div className="text-blue text-lg font-semibold my-2">Select Subject</div>
                            <Select dropdownData={getSubjectOptions(selectedGrade)} value={selectedSubject}
                                onChange={(e) => handleSubjectChange(e.target.value)}
                            />
                        </div>

                        <div className="my-8">
                            <div className="text-blue text-lg font-semibold my-2">Select Topics</div>
                            <Select dropdownData={tutorTopic[selectedGrade][selectedSubject] || []}
                                value={selectedTopic}
                                onChange={(e) => handleTopicChange(e.target.value)} />
                        </div>

                        <div className="my-8">
                            <div className="text-blue text-lg font-semibold my-2">Context</div>
                            <div className="w-full text-sm">

                                <textarea
                                    className="w-full border border-[#23479F] rounded-lg p-2"
                                    placeholder="Give context for story."
                                    value={currentContext}
                                    onChange={(e) =>
                                        setCurrentContext(e.target.value)
                                    }
                                    rows={1}
                                    disabled={!disableTextArea}
                                />
                            </div>
                        </div>

                        <div className="w-full rounded-lg my-6 text-base text-purple my-8">
                            <textarea
                                className="w-full border border-light-purple bg-light-purple p-2"
                                placeholder="Words to be included in the story."
                                value={textareaContent}
                                onChange={(e) => setTextareaContent(e.target.value)}
                                rows={6}
                                disabled={!disableTextArea}
                            />
                        </div>

                        <div className="my-8 flex justify-center">
                            <button
                                onClick={() => {
                                    setStream(true);
                                    setDisplayQuestionInput(false);
                                    storyGetOutput("Give story using difficult words", textareaContent, currentContext);
                                }}
                                disabled={isTextareaEmpty}
                                className={`${isTextareaEmpty
                                    ? "bg-gray-400 text-gray-700 cursor-not-allowed"
                                    : "bg-[#766AFF] hover:bg-[#544AC0] text-white"
                                    } px-6 py-3 tracking-wider leading-5 rounded-lg text-base font-bold font-heading`}
                            >
                                Generate
                            </button>
                        </div>
                        <ToastContainer />

                        {/* Display previous questions lists */}
                        <div className="my-8">
                            {messages.slice().reverse().map((entry, index) => (
                                <>
                                    {(index < 1) ? (
                                        <div className="my-3 text-lg font-medium text-indigo-800 text-left my-2">
                                            Previous Questions
                                        </div>
                                    ) : null}
                                    {entry?.fromUser &&
                                        <div
                                            key={entry.id}
                                            className={`border border-[#23479F] rounded-lg text-[#23479F] px-4 p-3 mb-3 ${entry.id === selectedQuestionId ? "bg-[#385EBA] text-white" : ""
                                                }`}
                                            onClick={() => scrollToAnswer(entry.id)}
                                        >
                                            <div className="line-clamp-1">
                                                {entry.text}
                                            </div>
                                        </div>
                                    }
                                </>
                            ))}
                        </div>
                    </div>
                </FullCard>
            </div>
            <div className="thirdcardWidth ">
                {/* chat history popup modal */}
                {showChatHistoryPopup && (
                    <Draggable>
                        <div className="z-50 absolute flex flex-col justify-between items-center inset-0 m-auto w-3/4 h-3/4 bg-white rounded-md shadow-lg border-2 p-4 overflow-hidden">
                            <div className="subheading flex justify-center text-center mb-4">
                                Chat History
                            </div>
                            <div className="flex-1 overflow-y-auto grid grid-cols-1 gap-4 w-full">
                                {chatHistory.map((session, index) => (
                                    <button
                                        key={index}
                                        className="flex flex-col p-4 bg-gray-100 border border-gray-300 rounded-lg hover:bg-gray-200 transition-all"
                                        onClick={() => {
                                            handleSessionClick(session);
                                            setShowChatHistoryPopup(false);
                                            setShowDownload(true)
                                        }}>
                                        <div className="mb-2"><strong>User:</strong>
                                            <span dangerouslySetInnerHTML={{
                                                __html: DOMPurify.sanitize(session.data[0]?.user)
                                            }} />
                                        </div>
                                        <div><strong>Timestamp:</strong> {formatDate(session.data[0]?.timestamp)}</div>
                                    </button>
                                ))}
                            </div>
                            {/* Button Row */}
                            <div className="flex gap-4 mt-4">
                                {/* Close button with icon */}
                                <Button
                                    onClick={() => { setShowChatHistoryPopup(false); setDisableTextArea(true); }}
                                >
                                    Close
                                </Button>
                            </div>
                        </div>
                    </Draggable>
                )}
                <div className="chat-container relative">
                    {(showDownload) && (<div>
                        <div className="absolute top-4 right-6 z-50">
                            <button
                                onClick={() => generatePDFForEntireChat()}
                            >
                                <Download />
                            </button>
                        </div>
                    </div>)}
                    <div className={`overflow-auto ${selectedRole === 'student' ? "h-[80vh]" : "h-[80vh]"}`} // ${selectedRole === 'student' ? "h-[70vh]" : "h-[78vh]"}
                        onScroll={handleScroll}
                        id="chat-box">
                        {/* Chat history */}
                        {selectedSession && (
                            <div
                                onScroll={handleScroll}
                            >
                                <div className="flex-1 grid grid-cols-1 gap-4 w-full">
                                    {selectedSession.data.map((item, index) => (
                                        <Card>
                                            <div className="chat-message relative">
                                                <div key={index} className="m-5">
                                                    <div className="flex">
                                                        <div className="w-1/12">
                                                            <img
                                                                src={questionIcon}
                                                                alt=""
                                                                width={"50px"}
                                                                height={"50px"}
                                                                className=""
                                                            />
                                                        </div>
                                                        <div className="w-11/12 ml-4 bg-white rounded-lg text-xl mb-4">
                                                            {item.user && <div className="w-full p-2"> {item.user}</div>}
                                                        </div>
                                                    </div>
                                                    <div className="flex">
                                                        <div className="w-1/12">
                                                            <img
                                                                src={ansIcon}
                                                                alt=""
                                                                width={"50px"}
                                                                height={"50px"}
                                                                className=""
                                                            />
                                                        </div>
                                                        <div className="w-11/12 ml-4 bg-white rounded-lg text-xl mb-4">
                                                            {item.bot &&
                                                                <div
                                                                    className="w-full p-2"
                                                                    dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(item.bot) }}
                                                                ></div>
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </Card>
                                    ))}
                                </div>
                            </div>
                        )}
                        {!(selectedSession) && (<div>
                            {/* Main Chat*/}
                            {pairwise(messages, (a, b, idx) => {
                                return <div
                                    key={a.id}
                                    ref={latestAnswerRef}
                                    className={`mb-4 ${a.id === selectedQuestionId ? "bg-gray-200" : ""} `}
                                    id={`answer-${a.id}`}
                                >
                                    <Card>
                                        <div className="chat-message relative">
                                            <div
                                                className="m-5">
                                                <div className="flex">
                                                    <div className="w-1/12">
                                                        <img
                                                            src={questionIcon}
                                                            alt=""
                                                            width={"50px"}
                                                            height={"50px"}
                                                            className=""
                                                        />
                                                    </div>
                                                    <div
                                                        className={` w-11/12 ml-4 bg-white rounded-lg text-xl mb-4 ${b?.id === selectedQuestionId ? "font-medium text-indigo-800" : ""}`}>

                                                        <div className="w-full p-2">
                                                            {a.text} {idx >= messages.length - 2 && (
                                                                <div className="readAloud flex flex-row gap-3">
                                                                    <div className="readAloud1 flex flex-row gap-3">
                                                                        <Button
                                                                            onClick={() => {
                                                                                readAloud(idx + 1, englishAnswer);
                                                                            }}
                                                                        >
                                                                            <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 16 16">
                                                                                <path fill="currentColor" d="M10.044 1.498a.75.75 0 0 1 .958-.454c.214.09.001 0 .001 0h.001l.003.001l.005.003l.015.005a2 2 0 0 1 .19.08c.118.056.28.138.47.253c.379.23.876.596 1.37 1.143C14.057 3.636 15 5.44 15 8.249a.75.75 0 0 1-1.5 0c0-2.44-.807-3.885-1.556-4.715a4.7 4.7 0 0 0-1.036-.865a3 3 0 0 0-.401-.209l-.014-.005a.75.75 0 0 1-.45-.957M7.198 3.475a.75.75 0 0 0-1.395 0l-3.75 9.5a.75.75 0 0 0 1.395.55l.898-2.275h4.308l.898 2.275a.75.75 0 1 0 1.396-.55zm.864 6.275H4.938L6.5 5.793zm2.668-6.076a.75.75 0 0 0-.962 1.15l.006.006l.034.03q.049.045.139.136c.12.123.28.304.44.53c.327.463.613 1.063.613 1.724a.75.75 0 0 0 1.5 0c0-1.088-.464-1.989-.887-2.588a6 6 0 0 0-.853-.962l-.02-.017l-.006-.005l-.002-.002zm-.962 1.15l.001.002Z" />
                                                                            </svg>
                                                                        </Button>
                                                                        <Button
                                                                            onClick={() => {
                                                                                stopReadAloud();
                                                                            }}
                                                                        >
                                                                            <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24">
                                                                                <path fill="currentColor" d="M7 17V7h10v10z" />
                                                                            </svg>
                                                                        </Button>
                                                                    </div>

                                                                </div>
                                                            )}

                                                        </div>
                                                    </div>
                                                </div>

                                                {b && <div>
                                                    <div className="flex">
                                                        <div className="w-1/12">
                                                            <img
                                                                src={ansIcon}
                                                                alt=""
                                                                width={"50px"}
                                                                height={"50px"}
                                                                className=""
                                                            />
                                                        </div>
                                                        <div className="w-11/12 ml-4 bg-white rounded-lg text-xl">
                                                            {translatedText && translate && idx >= messages.length - 2 ?
                                                                <div id={`bot-response${idx}`}
                                                                    className="w-full p-2 bot-response translatedResponse"
                                                                    dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(translatedText) }}
                                                                ></div> :
                                                                <div id={`bot-response${idx}`}
                                                                    className="w-full p-5 bot-response "
                                                                    dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(b.text) }}
                                                                ></div>}

                                                            {/* after text buttons */}
                                                            <div className="flex items-center justify-between p-4">
                                                                <div className="flex items-center space-x-2">
                                                                    <button
                                                                        id={`like-bot-response-${bIndex}`}
                                                                        onClick={handleLike(bIndex)}
                                                                        className="p-1 hover:bg-gray-100 rounded-full transition-colors"
                                                                    >
                                                                        <ThumbsUp className="w-5 h-5" />
                                                                    </button>
                                                                    <button
                                                                        id={`dislike-bot-response-${bIndex}`}
                                                                        onClick={handleDislike(bIndex)}
                                                                        className="p-1 hover:bg-gray-100 rounded-full transition-colors"
                                                                    >
                                                                        <ThumbsDown className="w-5 h-5" />
                                                                    </button>
                                                                    <button
                                                                        onClick={() => handleCopyText(`bot-response${idx}`)}
                                                                        className="p-1 hover:bg-gray-100 rounded-full transition-colors"
                                                                    >
                                                                        <Copy className="w-5 h-5" />
                                                                    </button>
                                                                    <button
                                                                        className="p-1 hover:bg-gray-100 rounded-full transition-colors"
                                                                        onClick={() => generatePDF(a.text, b.text)}>
                                                                        <Download className="w-5 h-5" />
                                                                    </button>
                                                                </div>
                                                                {/* Increment bIndex for each b message */}
                                                                {(() => { bIndex++; })()}
                                                                {translate && idx >= messages.length - 2 && (
                                                                    <div className="flex items-center space-x-2">
                                                                        <SimpleDropdown
                                                                            defaultValue={translationLanguages[0]}
                                                                            onSelect={handleTranslationLanguageSelect}
                                                                            options={translationLanguages}
                                                                        />
                                                                        <Button
                                                                            onClick={() => {
                                                                                handleLanguageTranslation(idx + 1, englishAnswer);
                                                                            }}
                                                                        >
                                                                            Translate
                                                                        </Button>
                                                                    </div>
                                                                )}
                                                            </div>

                                                            {/* Conditionally render Card only if b.images exists and has elements */}
                                                            {b.images && b.images.length > 0 && (
                                                                <Card>
                                                                    <div className="grid grid-cols-3 gap-4">
                                                                        {b.images && b.images.map((src, index) => (
                                                                            <div key={index}>
                                                                                <div id="page-container">
                                                                                    <img src={src}
                                                                                        alt={`generate_image_${index}`}
                                                                                        className="w-full h-auto" />
                                                                                </div>
                                                                            </div>
                                                                        ))}
                                                                    </div>
                                                                </Card>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                                }
                                            </div>
                                            {imageFlag && idx >= messages.length - 2 &&
                                                <ImageSpinner
                                                    size='lg'
                                                />
                                            }
                                        </div>
                                    </Card>
                                </div>
                            }
                            ).map(component => component)}
                        </div>)}
                    </div>
                    <div className="fixed bottom-0 thirdCard bg-[#e5eeff]">
                        <div className="mr-10 ml-4 my-4">
                            {selectedFiles &&
                                <>
                                    <div className="relative py-[8px]">
                                        <span className="rounded-xl bg-white p-[5px]">
                                            {`Uploaded: ${selectedFiles.name}`}</span>
                                        <button onClick={() => { setSelectedFiles(null); }}
                                            className="bg-[#23479F] hover:bg-[#544AC0] px-1 py-0.5 tracking-tight leading-4 rounded-lg text-sm text-white font-bold font-heading absolute top-0">
                                            x
                                        </button>
                                    </div>
                                </>
                            }
                            {/* did not click on chat history */}
                            {!(selectedSession) && (<div>
                                <div className="flex">
                                    <div className="w-full text-lg">
                                        <textarea
                                            className="w-full border border-[#23479F] rounded-lg p-2"
                                            placeholder="Ask your question here....."
                                            value={currentQuestion}
                                            onChange={(e) =>
                                                setCurrentQuestion(e.target.value)
                                            }
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter' && !e.shiftKey) {
                                                    e.preventDefault();
                                                    setDisplayQuestionInput(false);
                                                    setStream(true);
                                                    handleSendMessage(currentQuestion, stream);
                                                }
                                            }}
                                            rows={1}
                                            disabled={!disableTextArea}
                                        />
                                        <div className="">
                                            {errorMessage && (
                                                <div className="text-red-600">
                                                    {errorMessage}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                    <div className=" ml-4">
                                        <div className="flex gap-[10px]">
                                            {selectedRole === 'teacher' && selectedTeacherMethod === 'Brainstorming' &&
                                                <ImageUpload
                                                    accept={"application/jpg"}
                                                    onChange={handleFileChange}
                                                />
                                            }
                                            {(selectedSubject) === 'Mathematics' && (<div>
                                                {/* Math Symbol Button */}
                                                <Button
                                                    onClick={() => setShowKeyboard(!showKeyboard)}
                                                >
                                                    π
                                                </Button>
                                                {/* Draggable Math Keyboard Panel */}
                                                {showKeyboard && (
                                                    <Draggable>
                                                        <div className="absolute bottom-20 right-10 z-50">
                                                            <MathKeyboard onSymbolClick={handleSymbolClick} />
                                                        </div>
                                                    </Draggable>
                                                )}
                                            </div>)}
                                            <Button
                                                onClick={() => {
                                                    if (currentQuestion.trim() === '') {
                                                        setErrorMessage('Text cannot be empty');
                                                        return;
                                                    }
                                                    setDisplayQuestionInput(false);
                                                    handleSendMessage(currentQuestion, stream);
                                                    setShowDownload(true);
                                                }}
                                                disabled={!disableTextArea}
                                            >
                                                Ask
                                            </Button>

                                            <Button
                                                onClick={openDialog}
                                                disabled={listening}
                                            >
                                                {listening ? 'Listening...' : <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24"><path fill="currentColor" d="M12 2a3 3 0 0 1 3 3v6a3 3 0 0 1-3 3a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3m7 9c0 3.53-2.61 6.44-6 6.93V21h-2v-3.07c-3.39-.49-6-3.4-6-6.93h2a5 5 0 0 0 5 5a5 5 0 0 0 5-5z" /></svg>}
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                            </div>)}
                            {/* clicked on chat history */}
                            {(selectedSession) && (<div>
                                {/* Buttons to navigate between chat sessions */}
                                <div className="flex justify-between mb-4">
                                    <Button
                                        onClick={handlePreviousClick}
                                        disabled={selectedSessionIndex === 0}
                                    >
                                        Previous
                                    </Button>

                                    <Button
                                        onClick={() => {
                                            clearAllVariables();
                                            setShowDownload(false);
                                        }}
                                    >
                                        Back
                                    </Button>

                                    <Button
                                        onClick={handleNextClick}
                                        disabled={selectedSessionIndex === chatHistory.length - 1}
                                    >
                                        Next
                                    </Button>
                                </div>
                            </div>)}
                        </div>
                    </div>
                </div>
            </div>
            {loading && (
                <div className="overlay">
                    <Spinner />
                </div>
            )};
        </div>
    )
}

export default ReadingComprehension;
